import React, { Component } from 'react';  // eslint-disable-line no-unused-vars
import { Icon } from 'antd';

function BtnPrev(props){
  const { id, onClick, ...otherProps } = props;
  const prev = parseInt(id, 10) - 1;

  const prevLesson = () => onClick(prev);

  if(prev > 0) {
    return (
      <Icon onClick={prevLesson} {...otherProps} id="btn-prev" type="caret-left" />
    )
  } else{
    return <Icon style={{visibility: 'hidden' }} id="btn-prev" type="caret-left" />
  }
}

export default BtnPrev;



// WEBPACK FOOTER //
// ./src/components/Buttons/BtnPrev.js